var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var CircleInfo = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 20 21" }, props),
        React.createElement("path", { fill: color, d: "M10 0c1.38 0 2.68.26 3.896.781a10.035 10.035 0 0 1 3.184 2.14 10.035 10.035 0 0 1 2.14 3.183A9.805 9.805 0 0 1 20 10c0 1.38-.26 2.68-.78 3.896a10.035 10.035 0 0 1-2.14 3.184 10.035 10.035 0 0 1-3.184 2.14A9.805 9.805 0 0 1 10 20c-1.38 0-2.679-.26-3.896-.78a10.035 10.035 0 0 1-3.184-2.14 10.035 10.035 0 0 1-2.14-3.184A9.801 9.801 0 0 1 0 10c0-1.38.26-2.679.781-3.896a10.035 10.035 0 0 1 2.14-3.184A10.035 10.035 0 0 1 6.103.78 9.801 9.801 0 0 1 10 0zm0 18.77a8.44 8.44 0 0 0 3.408-.694 8.83 8.83 0 0 0 2.774-1.885 9.035 9.035 0 0 0 1.875-2.783A8.44 8.44 0 0 0 18.75 10a8.44 8.44 0 0 0-.693-3.408 8.914 8.914 0 0 0-1.875-2.774 8.914 8.914 0 0 0-2.774-1.875A8.44 8.44 0 0 0 10 1.25a8.44 8.44 0 0 0-3.408.693 8.914 8.914 0 0 0-2.774 1.875 8.914 8.914 0 0 0-1.875 2.774A8.44 8.44 0 0 0 1.25 10c0 1.21.231 2.347.693 3.408a9.035 9.035 0 0 0 1.875 2.783 8.83 8.83 0 0 0 2.774 1.885A8.44 8.44 0 0 0 10 18.77zM10 8a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" })));
};
CircleInfo.defaultProps = {
    color: '#fff',
};
export default CircleInfo;
//# sourceMappingURL=CircleInfo.js.map